import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { TableCell, TableRow } from "@/components/ui/table";
import type { AdminStrategy } from "@/queries/adminStrategies";

interface Props {
  row: AdminStrategy;
  totalPlaybooks: number;
  onEdit: () => void;
  onDelete: () => void;
}

export function StrategyRow({ row, totalPlaybooks, onEdit, onDelete }: Props) {
  const { t } = useTranslation("admin-strategies");
  return (
    <TableRow>
      <TableCell className="font-medium">
        {row.name}
        {row.description ? (
          <div className="text-xs text-muted-foreground">{row.description}</div>
        ) : null}
      </TableCell>
      <TableCell className="text-sm tabular-nums">
        {t("playbookCount", {
          count: row.playbook_ids.length,
          total: totalPlaybooks,
        })}
      </TableCell>
      <TableCell className="text-right tabular-nums">
        ${row.daily_budget_usd}
      </TableCell>
      <TableCell className="text-right tabular-nums">
        {row.max_position_size_pct}
      </TableCell>
      <TableCell className="text-right tabular-nums">
        {row.cooldown_after_losing_trade_hours}
      </TableCell>
      <TableCell>
        <Badge variant={row.live_enabled ? "destructive" : "muted"}>
          {row.live_enabled ? "LIVE" : "paper"}
        </Badge>
      </TableCell>
      <TableCell className="text-right tabular-nums">
        {row.live_confidence_threshold}
      </TableCell>
      <TableCell className="text-right">
        <div className="flex justify-end gap-1">
          <Button variant="outline" size="sm" onClick={onEdit}>
            {t("actions.edit")}
          </Button>
          <Button variant="ghost" size="sm" onClick={onDelete}>
            {t("actions.delete")}
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
